export default __webpack_public_path__ + "static/media/of_6.cc59fae4.mp3";